import { Col, Input, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { t } from 'i18next';
import React from 'react';

const TabDetailDataGroup = ({ onChange, dataGropNameError, descriptionError, dataGroupName, description }) => {
  return (
    <>
      <Row className='mt-5'>
        <Col span={12}>
          <div>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("DATA_GROUP:LBL_DATA_GROUP_NAME")}
            </p>
            <Input
              style={dataGropNameError ? { width: '50%', border: '#CF0000 1px solid', borderRadius: '6px' } : { width: '50%' }}
              size='large'
              value={dataGroupName}
              placeholder={t("COMMON:TYPE", { field: t("DATA_GROUP:LBL_DATA_GROUP_NAME") })}
              onChange={(e) => onChange('dataGroupName', e.target.value)}
            />
            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${dataGropNameError ? `visible` : `hidden`}`}>This field is required</p>

          </div>
          <div className='mt-2'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("DATA_GROUP:LBL_DESCRIPTION")}
            </p>
            <TextArea
              style={descriptionError ? { width: '50%', border: '#CF0000 1px solid', borderRadius: '6px' } : { width: '50%' }}
              size='large'
              value={description}
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_ADDRESS") })}
              onChange={(e) => onChange('description', e.target.value)}
            />
            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${descriptionError ? `visible` : `hidden`}`}>This field is required</p>

          </div>
        </Col>
        <Col span={12}></Col>
      </Row>
    </>
  );
}

export default TabDetailDataGroup;